
  import { Component, Prop, Vue } from "vue-property-decorator";
  import DropdownOption from "@/entities/DropdownOption";

  @Component
  export default class MultiselectTag extends Vue {
    @Prop({ type: Object, required: true }) option!: DropdownOption;
    @Prop({ type: Object, default: () => ({}) }) tagMaxWidth!: Record<string, string>;
    @Prop({ type: Boolean, default: false }) single!: boolean;

    get containerClasses(): Record<string, boolean> {
      return {
        "mr-2 mb-2": !this.single,
        "-mt-1": this.single,
      };
    }
  }
